
// WebpackRequireFrom
typeof __webpack_require__ !== "undefined" && Object.defineProperty(__webpack_require__, "p", {
  get: function () {
try {
  if (typeof cabi_cdn !== "string") {
    throw new Error("WebpackRequireFrom: 'cabi_cdn' is not a string or not available at runtime. See https://github.com/agoldis/webpack-require-from#troubleshooting");
  }
  return cabi_cdn;
} catch (e) {
  if (!false) {
    console.error(e);
  }
  return "/";
}
 },
  set: function (newPublicPath) {
    console.warn("WebpackRequireFrom: something is trying to override webpack public path. Ignoring the new value" + newPublicPath  + ".");
}
});